import React, {Component} from 'react';
import {Row, Col, Button, Modal, Container} from 'react-bootstrap';

import Switch from 'react-switch';
import Form from 'react-bootstrap/Form';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NumberFormat from 'react-number-format';

const basePriceregEx = /^[1-9]\d*(\.\d+)?$/;

class AddCpvalue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {
        gst: this.props.ItemList ? this.props.ItemList.gst : null,
        serviceFee: this.props.ItemList ? this.props.ItemList.serviceFee : null,
        serviceFeePer: this.props.ItemList
          ? this.props.ItemList.serviceFeePer
          : null,
        gatewayFee: this.props.ItemList ? this.props.ItemList.gatewayFee : null,
      },
    };
    console.log('valuevaluevaluevaluevaluevalue', this.props.ItemList);
    this.onChange = this.onChange.bind(this);
    this.submit = this.submit.bind(this);
  }

  onChange = event => {
    let field = event.target.name;
    let value = event.target.value;

    if (field === 'gst') {
      // this.setState({
      //   value: {...this.state.value, gst: parseInt(value)},
      // });
      if (value === '' || basePriceregEx.test(value)) {
        this.setState({
          value: {...this.state.value, gst: value},
        });
      }
    } else if (field === 'serviceFee') {
      // this.setState({
      //   value: {...this.state.value, serviceFee: parseInt(value)},
      // });
      if (value === '' || basePriceregEx.test(value)) {
        this.setState({
          value: {...this.state.value, serviceFee: value},
        });
      }
    } else if (field === 'serviceFeePer') {
      // this.setState({
      //   value: {...this.state.value, serviceFeePer: parseInt(value)},
      // });
      if (value === '' || basePriceregEx.test(value)) {
        this.setState({
          value: {...this.state.value, serviceFeePer: value},
        });
      }
    } else if (field === 'gatewayFee') {
      // else if (field === 'gatewayFee') {
      //   this.setState({
      //     value: {...this.state.value, gatewayFee: parseInt(value)},
      //   });
      // }
      if (value === '' || basePriceregEx.test(value)) {
        this.setState({
          value: {...this.state.value, gatewayFee: value},
        });
      }
    }
    console.log('111111111111111111111!!!!!!!!!!!!!!!', value);
  };

  submit = () => {
    let data = this.state.value;

    if (
      data.gst !== '' &&
      data.serviceFee !== '' &&
      data.serviceFeePer !== '' &&
      data.gatewayFee !== ''
    ) {
      this.props.AddCpvalue(data);
      this.props.closeAddModel();
    } else {
      toast.error('All fields are mandatory', {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER,
      });
    }
    console.log('1data!!', data);
    console.log('this.props.AddCpvalue!', this.props.AddCpvalue());
  };

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: {
        gst: nextProps.ItemList && nextProps.ItemList.gst,
        serviceFee: nextProps.ItemList && nextProps.ItemList.serviceFee,
        serviceFeePer: nextProps.ItemList && nextProps.ItemList.serviceFeePer,
        gatewayFee: nextProps.ItemList && nextProps.ItemList.gatewayFee,
        id: nextProps.ItemList && nextProps.ItemList.id,
      },
    });
  }

  render() {
    return (
      <div>
        <div className="userModalDiv">
          <Modal
            show={this.props.showAddModel}
            onHide={this.props.closeAddModel}
            animation={false}
            size="lg"
            backdrop="static"
          >
            <Modal.Header
              style={{fontSize: '35px', backgroundColor: '#f0f3f5'}}
              closeButton
            >
              <Modal.Title>
                <span style={{fontSize: '20px'}}>Cp Value</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Container>
                <Form>
                  <Row>
                    <Col lg={6} md={12} sm={12} xs={12}>
                      <div>
                        <Form.Group controlId="gst">
                          <Form.Label> GST (%) </Form.Label>
                          {/* <NumberFormat
                            className="form-control"
                            value={this.state.value.gst}
                            suffix="%"
                            name="gst"
                            autoComplete="off"
                            decimalScale={0}
                            onChange={this.onChange}
                          /> */}
                          <Form.Control
                            type="number"
                            min="1"
                            autoComplete="off"
                            name="gst"
                            onChange={this.onChange}
                            value={this.state.value.gst || ''}
                          />
                        </Form.Group>
                      </div>
                      <div>
                        <Form.Group controlId="serviceFeePer">
                          <Form.Label> Service Fee Percentage (%) </Form.Label>

                          {/* <NumberFormat
                            className="form-control"
                            value={this.state.value.serviceFeePer}
                            suffix="%"
                            autoComplete="off"
                            decimalScale={0}
                            name="serviceFeePer"
                            onChange={this.onChange}
                          /> */}
                          <Form.Control
                            type="number"
                            min="1"
                            autoComplete="off"
                            name="serviceFeePer"
                            onChange={this.onChange}
                            value={this.state.value.serviceFeePer || ''}
                          />
                        </Form.Group>
                      </div>
                    </Col>

                    <Col lg={6} md={12} sm={12} xs={12}>
                      <div>
                        {/* <Form.Group controlId="serviceFee">
                          <Form.Label> Service Fee </Form.Label>
                          <NumberFormat
                            className="form-control"
                            value={this.state.value.serviceFee}
                            suffix="%"
                            onChange={this.onChange}
                            name="serviceFee"
                            autoComplete="off"
                            decimalScale={2}
                          />
                        </Form.Group> */}
                        <Form.Group
                          controlId="serviceFee"
                          style={{width: '100%'}}
                        >
                          <Form.Label> Service Fee (%) </Form.Label>
                          <Form.Control
                            type="number"
                            min="1"
                            autoComplete="off"
                            name="serviceFee"
                            onChange={this.onChange}
                            value={this.state.value.serviceFee || ''}
                          />
                        </Form.Group>
                      </div>

                      <div>
                        {/* <Form.Group controlId="gatewayFee">
                          <Form.Label> Gateway Fee </Form.Label>
                          <NumberFormat
                            className="form-control"
                            value={this.state.value.gatewayFee || ''}
                            suffix={'%'}
                            decimalScale={2}
                            onChange={this.onChange}
                            name="gatewayFee"
                            autoComplete="off"
                          />
                        </Form.Group> */}
                        <Form.Group
                          controlId="gatewayFee"
                          style={{width: '100%'}}
                        >
                          <Form.Label> Gateway Fee (%) </Form.Label>
                          <Form.Control
                            type="number"
                            min="1"
                            autoComplete="off"
                            name="gatewayFee"
                            onChange={this.onChange}
                            value={this.state.value.gatewayFee || ''}
                          />
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </Container>
            </Modal.Body>

            <Modal.Footer style={{backgroundColor: '#f0f3f5'}}>
              <Button className="CategorybtnSubmit" onClick={this.submit}>
                Submit
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}
export default AddCpvalue;
